module.exports = __webpack_public_path__ + "img/mobBar.c6812332.svg";